import { OAuthStorage } from 'angular-oauth2-oidc';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class customOAuthStorage extends OAuthStorage {
  // These keys MUST be unique per tab to prevent "wrong nonce" errors
  private tabSpecificKeys = ['nonce', 'state', 'PKCE_verifier', 'session_state'];

  getItem(key: string): string | null {
    return this.tabSpecificKeys.includes(key) 
      ? sessionStorage.getItem(key) 
      : localStorage.getItem(key);
  }

  setItem(key: string, data: string): void {
    this.tabSpecificKeys.includes(key) 
      ? sessionStorage.setItem(key, data) 
      : localStorage.setItem(key, data);
  }

  removeItem(key: string): void {
    this.tabSpecificKeys.includes(key) 
      ? sessionStorage.removeItem(key) 
      : localStorage.removeItem(key);
  }
}